import { render, staticRenderFns } from "./ModuleCard.vue?vue&type=template&id=14c227ed&scoped=true&"
import script from "./ModuleCard.vue?vue&type=script&lang=js&"
export * from "./ModuleCard.vue?vue&type=script&lang=js&"
import style0 from "./ModuleCard.vue?vue&type=style&index=0&id=14c227ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c227ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VDivider,VListItem,VListItemContent,VListItemTitle})
